// extracted by mini-css-extract-plugin
export var container = "projects-module--container--l2D8o";
export var current = "projects-module--current---tZeh";
export var description = "projects-module--description--k3rrU";
export var previewContainer = "projects-module--previewContainer--WVJ5L";
export var previews = "projects-module--previews--Fow+2";